import React from 'react';
import ScreenLayout from 'components/ScreenLayout';
import PrivacyPolicySection from './components/PrivacyPolicySection';

const PrivacyPolicyScreen: React.FC = () => {

  return (
    <ScreenLayout disableModal>
      <PrivacyPolicySection />
    </ScreenLayout>
  )
}

export default PrivacyPolicyScreen
